import React, { useEffect, useState } from "react";
import styles from "../subscription/Subscription.module.css";
import {
  subscriptionTabs,
  getAnalyticsData,
} from "./SubscriptionData";
import SubscriptionList from "./SubscriptionList";
import Webhooks from "./Webhooks";
import Settings from "./Settings";
import Analytics from "./Analytics";
import Plans from "./Plans";
import Promos from "./Promos";
import useUrlTab from "../../hooks/useUrlTab";

const Subscription = () => {
  const [activeTab, setActiveTab] = useUrlTab(subscriptionTabs, subscriptionTabs[0]);
  const [analytics, setAnalytics] = useState({});


  useEffect(() => {
    const fetchAnalytics = async () => {
      const analyticsResult = await getAnalyticsData();
      setAnalytics(analyticsResult);
    };
    fetchAnalytics();
  }, []);


  const handleTabClick = (tabName) => {
    setActiveTab(tabName);
  };

  const renderTabContent = () => {
  switch (activeTab) {
    case "Subscriptions":
      return <SubscriptionList />;

    case "Plans":
      return <Plans />;

    case "Promos":
      return <Promos />;

    case "Webhooks":
      return <Webhooks  />;

    case "Settings":
      return <Settings />;

    case "Analytics":
      return <Analytics analytics={analytics} />;

    default:
      return null;
  }
};


  const {
    totalSubscriptions,
    activeSubscriptions,
    monthlyRevenue,
    trialUsers,
  } = analytics;
  return (
    <div className={styles["subscription-container"]}>
      {/* Header Section */}
      <div className={styles["header"]}>
        <h1 className={styles["title"]}>Subscription Plans</h1>
        <p className={styles["subtitle"]}>
          Manage, Pay subscriptions, webhooks, and analytics
        </p>
      </div>

      {/* Top Cards */}
      <div className={styles["card-grid"]}>
        <div className={styles.card}>
          <p>
            Total Subscriptions
            <span className={styles["card-info"]} tabIndex={0}>
              i
              <span className={styles["card-info-tooltip"]}>
                All subscriptions ever recorded, on any platform.
              </span>
            </span>
          </p>
          <h2>{totalSubscriptions}</h2>
        </div>
        <div className={styles.card}>
          <p>
            Active Subscriptions
            <span className={styles["card-info"]} tabIndex={0}>
              i
              <span className={styles["card-info-tooltip"]}>
                Currently paying subscribers on any platform, free tier excluded.
              </span>
            </span>
          </p>
          <h2>{activeSubscriptions}</h2>
        </div>
        <div className={styles.card}>
          <p>
            Monthly Revenue
            <span className={styles["card-info"]} tabIndex={0}>
              i
              <span className={styles["card-info-tooltip"]}>
                Recurring revenue from Active Subscriptions only, not all-time revenue.
              </span>
            </span>
          </p>
          <h2 className={styles.revenue}>{monthlyRevenue}</h2>
        </div>
        <div className={styles.card}>
          <p>
            Trial Users
            <span className={styles["card-info"]} tabIndex={0}>
              i
              <span className={styles["card-info-tooltip"]}>
                Subscribers currently in an open free trial.
              </span>
            </span>
          </p>
          <h2 className={styles.cancelled}>{trialUsers}</h2>
        </div>
      </div>


      {/* Tabs */}
      <div className={styles.tabs}>
        {subscriptionTabs.map((tab) => (
          <button
            key={tab}
            className={`${styles.tab} ${activeTab === tab ? styles.active : ""}`}
            onClick={() => handleTabClick(tab)}
          >
            {tab}
          </button>
        ))}
      </div>

      {/* Tab Content */}
      {renderTabContent()}
    </div>
  );
};

export default Subscription;
